/* istanbul ignore file */
import React from 'react';
import { Box, Grid2 as Grid, Stack, SxProps, Typography } from '@mui/material';
import ListFilterWrapper from '../ListPageLayout/ListFilterWrapper';
import { topButtonsSx } from 'framework/ui/layout/ShowPageLayout/topButtonsSx';

interface RelationListLayoutProps {
  header?: React.ReactNode;
  actions?: React.ReactElement[];
  children: React.ReactElement;
  filter?: React.ReactElement;
  search?: React.ReactElement;
  sxFilter?: SxProps;
  sxHeaderContainer?: SxProps;
  isSmallLoader?: boolean;
  headerVariant?: 'h1' | 'h2' | 'h3' | 'h4';
  sx?: SxProps;
}

const RelationListLayout = ({
  header,
  actions,
  children,
  filter,
  search,
  sxFilter,
  sxHeaderContainer,
  sx,
  headerVariant = 'h2',
  isSmallLoader = true,
}: RelationListLayoutProps) => {
  return (
    <Box
      component="section"
      className="single-entry-info-block relation-list"
      sx={[
        {
          textAlign: 'left',
          '& .sort-btn': { margin: 0 },
          '& .alert': { textAlign: 'center' },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      <Grid
        container
        className="relations-heading"
        sx={[
          { marginBottom: '32px' },
          ...(Array.isArray(sxHeaderContainer) ? sxHeaderContainer : sxHeaderContainer ? [sxHeaderContainer] : []),
        ]}
      >
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography
            variant={headerVariant}
            component={headerVariant}
            color={headerVariant === 'h1' || headerVariant === 'h2' ? 'brand' : 'primary'}
          >
            {header}
          </Typography>
        </Grid>
        <Grid
          size={{ xs: 12, sm: 6 }}
          sx={theme => ({
            [theme.breakpoints.down('sm')]: {
              marginTop: '20px',
            },
          })}
        >
          <Stack
            className="top-btns"
            sx={theme => ({
              ...topButtonsSx,
              justifyContent: 'flex-end',
              alignItems: 'flex-start',
              [theme.breakpoints.down('sm')]: { justifyContent: 'flex-start' },
            })}
          >
            {actions}
          </Stack>
        </Grid>
      </Grid>
      {!!filter && !search && (
        <Box className="list-top-btns" sx={{ marginBottom: '17px', minHeight: 'auto', marginTop: 0 }}>
          {filter}
        </Box>
      )}
      {!!filter && !!search && <ListFilterWrapper filter={filter} search={search} sx={sxFilter} />}

      {React.cloneElement(children, { isSmallLoader })}
    </Box>
  );
};

export default RelationListLayout;
